<template>
    <div
        class="links__tile"
        :class="{'links__tile--active': isActive}"
    >
        <div class="links__tile__icon">
            <icon
                :icon="link.icon"
                :height="25"
                :width="25"
            >
            </icon>
            <span v-if="link.counter" class="links__tile__counter">
                {{ link.counter }}
            </span>
        </div>
        <p class="links__tile__link-name">
            {{ link.name }}
        </p>
    </div>
</template>

<script>
import SideMenuObject from '@/components/layout/SideMenu/SideMenuItemObject'
import Icon from '@/components/atoms/Icon'

export default {
    name: 'SideMenuItem',
    components: { Icon },
    props: {
        link: {
            type: SideMenuObject,
            required: true
        },
        isActive: {
            type: Boolean,
            required: false,
            default: false
        }
    }
}
</script>

<style scoped lang="scss">
@mixin tile-common {
    color: $font;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    background: transparent;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-weight: bold;
    font-size: .95rem;
}

.links__tile {
    position: relative;
    background: $secondary;
    &__icon {
        @include tile-common;
        padding: 20px 0 10px 0;
    }
    &__link-name {
        @include tile-common;
        padding-bottom: 20px;
    }
    &__counter {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .7rem;
        width: 22px;
        height: 18px;
        top: 10%;
        left: 60%;
        font-weight: 900;
        background: #F52063;
        border-radius: 40%;
    }
    &:hover, &--active, .router-link-exact-active {
        .links__tile__icon,
        .links__tile__link-name {
            //background: rgba($primary-rgb, .4);
            background: rgba(55, 59, 72, .6)
        }
    }
}
</style>
